import { Hero } from './Modal.styles.js';
import { type HTMLAttributes } from 'react';

type ModalHeroProps = HTMLAttributes<HTMLParagraphElement>;

const ModalHero = ({ children }: ModalHeroProps) => {
  return <Hero>{children}</Hero>;
};

ModalHero.displayName = 'Modal.Hero';

export { ModalHero };
